import React from 'react';
import { Typography, Tag, Button, Input } from 'antd';

const { Text } = Typography;
const { TextArea } = Input;

// Componente puramente presentacional, extraído da tela de chamada do
// Portal do Professor (frontend/src/components/portal_professor/
// ChamadaDetalhe.js) para uso também na Gestão Administrativa de
// Presenças (Fase D). Extração DELIBERADAMENTE só de apresentação --
// nenhuma chamada de API, nenhuma regra de negócio, nenhum acoplamento
// a rota/service de nenhuma das duas superfícies. O Portal NÃO foi
// alterado para usar este componente (zero risco de regressão numa tela
// já em produção) -- ChamadaDetalhe.js mantém sua própria cópia
// idêntica, intocada. Duplicação pequena e deliberada, preferível ao
// acoplamento, conforme decisão explícita desta fase.
export const STATUS_ALUNO_OPCOES = [
  { value: 'PRESENTE', label: 'Presente', color: '#389e0d' },
  { value: 'AUSENTE', label: 'Ausente', color: '#cf1322' },
  { value: 'JUSTIFICADA', label: 'Justificada', color: '#d48806' },
];

const AlunoChamadaLinha = ({
  aluno,
  somenteLeitura,
  observacaoAberta,
  onMudarStatus,
  onMudarObservacao,
  onAbrirObservacao,
}) => {
  const naoInformado = aluno.status_frequencia === 'NAO_INFORMADA';
  const inputId = `aluno-chamada-observacao-${aluno.matricula_id}`;

  return (
    <div className="aluno-chamada-linha" data-testid="aluno-chamada-linha">
      <div className="aluno-chamada-linha__nome">
        <Text strong id={`aluno-chamada-nome-${aluno.matricula_id}`}>
          {aluno.nome_completo}
        </Text>
        {naoInformado && (
          <Tag color="default" style={{ marginLeft: 8 }}>
            Não informado
          </Tag>
        )}
      </div>

      {somenteLeitura ? (
        <Tag color={STATUS_ALUNO_OPCOES.find((o) => o.value === aluno.status_frequencia)?.color || 'default'}>
          {STATUS_ALUNO_OPCOES.find((o) => o.value === aluno.status_frequencia)?.label ||
            (naoInformado ? 'Não informado' : aluno.status_frequencia)}
        </Tag>
      ) : (
        <>
          <div
            className="aluno-chamada-linha__status-opcoes"
            role="group"
            aria-labelledby={`aluno-chamada-nome-${aluno.matricula_id}`}
          >
            {STATUS_ALUNO_OPCOES.map((opcao) => {
              const selecionado = aluno.status_frequencia === opcao.value;
              return (
                <Button
                  key={opcao.value}
                  className="aluno-chamada-linha__status-btn"
                  aria-pressed={selecionado}
                  aria-label={`Marcar ${aluno.nome_completo} como ${opcao.label}`}
                  type={selecionado ? 'primary' : 'default'}
                  style={selecionado ? { backgroundColor: opcao.color, borderColor: opcao.color } : undefined}
                  onClick={() => onMudarStatus(aluno.matricula_id, opcao.value)}
                >
                  {opcao.label}
                </Button>
              );
            })}
          </div>

          {observacaoAberta ? (
            <TextArea
              id={inputId}
              aria-label={`Observação sobre ${aluno.nome_completo}`}
              value={aluno.observacao || ''}
              onChange={(e) => onMudarObservacao(aluno.matricula_id, e.target.value)}
              placeholder="Observação (opcional)"
              autoSize={{ minRows: 1, maxRows: 4 }}
              maxLength={500}
              style={{ marginTop: 8 }}
            />
          ) : (
            <Button
              type="link"
              size="small"
              onClick={() => onAbrirObservacao(aluno.matricula_id)}
              style={{ paddingLeft: 0, marginTop: 4 }}
            >
              + Adicionar observação
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export default AlunoChamadaLinha;
